import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtohospettaxifare() {



    const cardData = {




keyword: "Belgaum to Hospet Taxi Fare",

headingDescription: "Belgaum Taxi Service provides affordable and transparent Belgaum to Hospet taxi fare options for travelers looking for comfortable and reliable outstation transportation. We offer one-way taxi, round-trip cab, and customized travel solutions from Belgaum to Hospet with well-maintained vehicles and professional drivers. Our cab options include Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars based on your travel requirements. The taxi fare depends on vehicle type, travel distance, trip duration, and selected package. With doorstep pickup, flexible timings, experienced chauffeurs, clean vehicles, easy booking, and 24/7 customer assistance, Belgaum Taxi Service ensures a smooth and hassle-free journey. Whether you are traveling for business, family trips, sightseeing, educational purposes, or visiting nearby heritage destinations, we provide comfortable taxi services at competitive prices with complete travel convenience.",

topPlaces: [
  {
    title: "Hospet",
    description: "Hospet, officially known as Hosapete, is an important city in Karnataka and the main gateway to the famous Hampi heritage destination. The city is known for tourism, industries, markets, and excellent connectivity, making it a popular travel destination from Belgaum."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site and one of Karnataka's most famous tourist attractions. It is known for ancient temples, royal palaces, massive stone structures, historical ruins, and the magnificent heritage of the Vijayanagara Empire."
  },
  {
    title: "Virupaksha Temple",
    description: "Virupaksha Temple is one of the oldest and most important temples in Hampi dedicated to Lord Shiva. Its beautiful architecture, religious importance, and historical value attract thousands of visitors throughout the year."
  },
  {
    title: "Tungabhadra Dam",
    description: "Tungabhadra Dam near Hospet is a scenic attraction known for its reservoir, gardens, peaceful surroundings, and beautiful views. It is a popular place for families and tourists looking for relaxation."
  },
  {
    title: "Anegundi",
    description: "Anegundi is a historic village near Hampi known for ancient temples, heritage sites, traditional villages, and scenic landscapes. It is an excellent destination for travelers interested in culture and history."
  },
  {
    title: "Badami",
    description: "Badami is a famous heritage destination in Karnataka known for its rock-cut cave temples, sandstone cliffs, and Chalukyan architecture. It is a preferred sightseeing location for history lovers."
  },
  {
    title: "Pattadakal",
    description: "Pattadakal is a UNESCO World Heritage Site famous for its group of ancient temples showcasing remarkable architectural styles. It is a popular destination for heritage tours from Hospet."
  },
  {
    title: "Aihole",
    description: "Aihole is a historical village known for ancient temples and architectural experiments from the Chalukya period. It attracts tourists, students, and history enthusiasts exploring Karnataka heritage sites."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's major IT and business hub with corporate offices, technology parks, shopping destinations, and entertainment areas. Private cabs provide comfortable connectivity for long-distance travelers."
  },
  {
    title: "Goa",
    description: "Goa is a popular coastal holiday destination known for beaches, resorts, churches, nightlife, and water activities. Travelers often combine Hampi-Hospet trips with Goa vacations for a complete Karnataka-Goa tour experience."
  }
],




"services": [
  {
    "name": "Belgaum to Hospet Taxi Fare",
    "description": "Check Belgaum to Hospet Taxi Fare for affordable and transparent pricing with comfortable AC vehicles and professional drivers. Get reliable taxi options for one way, round trip, family travel, business trips, and outstation journeys with flexible fare packages."
  },
  {
    "name": "Belgaum to Hospet Cab",
    "description": "Book Belgaum to Hospet Cab for safe, comfortable, and convenient travel with experienced chauffeurs and well-maintained vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for personal, family, and corporate travel needs."
  },
  {
    "name": "Belgaum to Hospet Taxi",
    "description": "Hire Belgaum to Hospet Taxi service for reliable intercity transportation with professional drivers, clean vehicles, and affordable travel solutions. Enjoy a smooth journey with flexible one way and round trip booking options."
  },
  {
    "name": "Belgaum to Hospet Cab Service",
    "description": "Get Belgaum to Hospet Cab Service for comfortable outstation travel with doorstep pickup, trained chauffeurs, and premium vehicles. Our taxi services are ideal for family trips, business travel, sightseeing, and long-distance journeys."
  },
  {
    "name": "Belgaum to Hospet Taxi Service",
    "description": "Choose Belgaum to Hospet Taxi Service for safe and reliable transportation with experienced drivers, affordable pricing, and multiple vehicle options. Travel conveniently between Belgaum and Hospet with hassle-free booking facilities."
  },
  {
    "name": "Belgaum to Hospet One Way Cab",
    "description": "Book Belgaum to Hospet One Way Cab for economical single-direction travel without return charges. Enjoy comfortable AC cars, fixed pricing, professional drivers, and convenient pickup services."
  },
  {
    "name": "Belgaum to Hospet One Way Taxi",
    "description": "Reserve Belgaum to Hospet One Way Taxi for budget-friendly travel with reliable chauffeurs and comfortable vehicles. Perfect for passengers looking for affordable and convenient one way transportation."
  },
  {
    "name": "Belgaum to Hospet Cab Booking",
    "description": "Complete Belgaum to Hospet Cab Booking online with easy reservations, quick confirmation, and flexible travel options. Select your preferred vehicle category and enjoy a comfortable journey with professional drivers."
  },
  {
    "name": "Belgaum to Hospet Taxi Booking",
    "description": "Book Belgaum to Hospet Taxi Booking services for reliable and convenient travel with experienced chauffeurs. Get clean AC vehicles, affordable fares, and customized travel solutions for personal and business requirements."
  },
  {
    "name": "Belgaum to Hospet Car Rental",
    "description": "Choose Belgaum to Hospet Car Rental for private chauffeur-driven cars with comfortable seating and professional service. Ideal for family trips, corporate travel, sightseeing tours, and outstation transportation."
  },
  {
    "name": "Belgaum to Hospet Outstation Cab",
    "description": "Hire Belgaum to Hospet Outstation Cab for safe and comfortable long-distance travel. Enjoy reliable cabs with experienced drivers, transparent pricing, and flexible one way or round trip packages."
  },
  {
    "name": "Belgaum to Hospet Innova Crysta Cab",
    "description": "Book Belgaum to Hospet Innova Crysta Cab for premium and spacious travel with luxury seating, large luggage space, and experienced chauffeurs. Perfect for family groups, corporate journeys, and comfortable outstation trips."
  },
  {
    "name": "Belgaum to Hospet Ertiga Cab",
    "description": "Choose Belgaum to Hospet Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Ideal for family vacations, airport transfers, and long-distance journeys."
  },
  {
    "name": "Belgaum to Hospet Sedan Cab",
    "description": "Book Belgaum to Hospet Sedan Cab for economical and comfortable travel with clean AC cars and professional drivers. Suitable for couples, business passengers, and smooth highway travel."
  },
  {
    "name": "Belgaum to Hospet Round Trip Cab",
    "description": "Hire Belgaum to Hospet Round Trip Cab for convenient return journeys with affordable packages and flexible schedules. Perfect for sightseeing, family visits, business meetings, and weekend travel."
  },
  {
    "name": "Belgaum to Hospet Private Taxi",
    "description": "Reserve Belgaum to Hospet Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and hassle-free transportation throughout your journey."
  },
  {
    "name": "Cheap Belgaum to Hospet Cab",
    "description": "Find Cheap Belgaum to Hospet Cab services offering affordable fares with quality vehicles and reliable drivers. Travel comfortably without compromising safety, convenience, and service standards."
  },
  {
    "name": "Best Belgaum to Hospet Taxi Service",
    "description": "Choose the Best Belgaum to Hospet Taxi Service with premium vehicles, trained drivers, competitive rates, and dependable customer support. Experience smooth and comfortable travel for all journey requirements."
  },
  {
    "name": "Online Belgaum to Hospet Cab Booking",
    "description": "Complete Online Belgaum to Hospet Cab Booking with simple reservations, instant confirmation, and flexible travel choices. Get convenient doorstep pickup with Sedan, Ertiga, Innova Crysta, and SUV options."
  },
  {
    "name": "Belgaum to Hospet Taxi Fare",
    "description": "Get affordable Belgaum to Hospet Taxi Fare with transparent pricing and no hidden charges. Choose comfortable cabs with professional drivers for safe and economical travel."
  },
  {
    "name": "Belgaum to Hospet Car Hire",
    "description": "Hire Belgaum to Hospet Car Hire services for private transportation with chauffeur-driven vehicles. Select from multiple car categories suitable for personal, family, and corporate travel."
  },
  {
    "name": "Belgaum to Hospet Cab Price",
    "description": "Check Belgaum to Hospet Cab Price for competitive travel packages with flexible one way and round trip options. Enjoy reliable service, comfortable vehicles, and professional chauffeurs."
  },
  {
    "name": "Belgaum to Hospet Family Cab",
    "description": "Book Belgaum to Hospet Family Cab for safe and comfortable family journeys with spacious vehicles and experienced drivers. Perfect for vacations, functions, temple visits, and personal travel."
  },
  {
    "name": "Belgaum to Hospet Corporate Taxi",
    "description": "Choose Belgaum to Hospet Corporate Taxi services for business travel, employee transportation, and executive journeys. Get punctual service with professional chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Belgaum to Hospet Airport Transfer",
    "description": "Book Belgaum to Hospet Airport Transfer services for timely pickup and drop with comfortable vehicles and experienced drivers. Enjoy stress-free airport transportation with reliable cab availability."
  },
  {
    "name": "Belgaum to Hospet Cab Fare",
    "description": "Get the best Belgaum to Hospet Cab Fare with affordable packages and transparent rates. Travel comfortably with Sedan, Ertiga, Innova Crysta, and premium cab options."
  },
  {
    "name": "Belgaum to Hospet Taxi Near Me",
    "description": "Find Belgaum to Hospet Taxi Near Me for quick cab availability and reliable transportation. Enjoy easy booking, doorstep pickup, comfortable vehicles, and professional driver services."
  },
  {
    "name": "Belgaum to Hospet Outstation Taxi",
    "description": "Book Belgaum to Hospet Outstation Taxi for safe and convenient long-distance travel. Get clean AC vehicles, skilled chauffeurs, and flexible travel plans for personal and corporate journeys."
  },
  {
    "name": "Belgaum to Hospet Travel by Cab",
    "description": "Experience comfortable Belgaum to Hospet Travel by Cab with reliable transportation, professional drivers, and premium vehicle options. Enjoy a smooth journey with customized travel solutions and convenient pickup services."
  }
],
"tableData": [
  ["Belgaum to Hospet Taxi Fare", "Belgaum to Hospet Cab"],
  ["Belgaum to Hospet Taxi", "Belgaum to Hospet Cab Service"],
  ["Belgaum to Hospet Taxi Service", "Belgaum to Hospet One Way Cab"],
  ["Belgaum to Hospet One Way Taxi", "Belgaum to Hospet Cab Booking"],
  ["Belgaum to Hospet Taxi Booking", "Belgaum to Hospet Car Rental"],
  ["Belgaum to Hospet Outstation Cab", "Belgaum to Hospet Innova Crysta Cab"],
  ["Belgaum to Hospet Ertiga Cab", "Belgaum to Hospet Sedan Cab"],
  ["Belgaum to Hospet Round Trip Cab", "Belgaum to Hospet Private Taxi"],
  ["Cheap Belgaum to Hospet Cab", "Best Belgaum to Hospet Taxi Service"],
  ["Online Belgaum to Hospet Cab Booking", "Belgaum to Hospet Taxi Fare"],
  ["Belgaum to Hospet Car Hire", "Belgaum to Hospet Cab Price"],
  ["Belgaum to Hospet Family Cab", "Belgaum to Hospet Corporate Taxi"],
  ["Belgaum to Hospet Airport Transfer", "Belgaum to Hospet Cab Fare"],
  ["Belgaum to Hospet Taxi Near Me", "Belgaum to Hospet Outstation Taxi"],
  ["Belgaum to Hospet Travel by Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Affordable Belgaum to Hospet Taxi Fare",
    WhyChoosedescription: "Get transparent taxi fare options for travelling from Belgaum to Hospet with comfortable cabs, professional drivers, and flexible packages suitable for different travel needs."
  },
  {
    WhyChooseheading: "Fare Options Based on Your Vehicle Choice",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs with pricing based on vehicle type, passenger capacity, and comfort preference."
  },
  {
    WhyChooseheading: "Private Cab with No Sharing",
    WhyChoosedescription: "Travel in a dedicated taxi where the vehicle is reserved only for you, providing privacy, convenience, and better control over your journey."
  },
  {
    WhyChooseheading: "Suitable for Hampi & Hospet Trips",
    WhyChoosedescription: "Our Belgaum to Hospet taxis are ideal for travellers visiting Hospet, Hampi sightseeing, family trips, business visits, and personal journeys."
  },
  {
    WhyChooseheading: "Experienced Drivers & Smooth Travel",
    WhyChoosedescription: "Professional drivers ensure safe driving, proper route knowledge, and a comfortable experience throughout the Belgaum to Hospet journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Fare Plans",
    WhyChoosedescription: "Select a one-way taxi fare for direct travel or choose a round-trip package according to your return schedule and travel requirements."
  },
  {
    WhyChooseheading: "Comfortable Cars for Long Distance Routes",
    WhyChoosedescription: "Well-maintained vehicles with clean interiors and spacious seating make the journey from Belgaum to Hospet relaxing and convenient."
  },
  {
    WhyChooseheading: "Quick Fare Enquiry & Booking Support",
    WhyChoosedescription: "Get assistance for current taxi fare details, vehicle availability, and booking confirmation for your Belgaum to Hospet travel."
  }
]

};

const faqData = [
  {
    question: "How much is the Belgaum to Hospet Taxi Fare?",
    answer: "The taxi fare depends on the selected vehicle type, travel plan, number of passengers, and whether you choose one-way or round-trip service."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Hospet?",
    answer: "Yes, one-way taxi service is available for passengers who need direct transportation without a return journey."
  },
  {
    question: "Which vehicles are available for Belgaum to Hospet travel?",
    answer: "You can choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs based on your comfort and group size."
  },
  {
    question: "Is Belgaum to Hospet taxi suitable for Hampi sightseeing?",
    answer: "Yes, the taxi can be used for travelling to Hospet and nearby Hampi sightseeing destinations with customized travel plans."
  },
  {
    question: "Can I get a return taxi from Hospet to Belgaum?",
    answer: "Yes, return trip taxi options are available with flexible timings according to your travel schedule."
  },
  {
    question: "Does the taxi fare include toll and parking charges?",
    answer: "Toll, parking, and other applicable charges depend on the selected package and are communicated during fare confirmation."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I book a private cab for family travel?",
    answer: "Yes, private taxis are available with dedicated vehicles suitable for families, groups, and long-distance travel."
  },
  {
    question: "Is Belgaum to Hospet taxi available 24/7?",
    answer: "Yes, taxi booking assistance is available for planned journeys and urgent travel requirements."
  },
  {
    question: "How can I check the exact Belgaum to Hospet Taxi Fare?",
    answer: "Share your travel date, pickup location, passenger details, and preferred vehicle type to get the latest fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Patil",
    feedback: "I checked the Belgaum to Hospet taxi fare and booked a comfortable cab for my Hampi visit. The service was smooth and the driver was very cooperative.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavya Desai",
    feedback: "The taxi fare was reasonable and the journey was comfortable. The vehicle was clean, and the driver managed the route very well.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Hospet Taxi Fare",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-hospet-taxi-fare.webp",
  "description":
    "Book Belgaum to Hospet Taxi Fare with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Hospet with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, Hampi sightseeing, family trips, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-hospet-taxi-fare"
  }
};







    return (
        <div>



<Helmet>
  <title>Belgaum to Hospet Taxi Fare | One Way Cab | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Hospet Taxi Fare with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Hospet with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel and Hampi trips available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Hospet Taxi Fare, Belgaum to Hospet Cab, Belgaum to Hospet Taxi, Belgaum to Hospet Cab Service, Belgaum to Hospet Taxi Service, Belgaum to Hospet One Way Cab, Belgaum to Hospet One Way Taxi, Belgaum to Hospet Cab Booking, Belgaum to Hospet Taxi Booking, Belgaum to Hospet Car Rental, Belgaum to Hospet Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtohospettaxifare ;